import React, { createContext, useContext } from 'react';

/** DOM node at the bottom of each page where data-source badges are portalled. */
export const PageSourcesContext = createContext<HTMLElement | null>(null);
export function usePageSourcesSlot(): HTMLElement | null {
  return useContext(PageSourcesContext);
}
export function PageSourcesProvider({
  slot,
  children
}: {
  slot: HTMLElement | null;
  children: React.ReactNode;
}) {
  return <PageSourcesContext.Provider value={slot} data-id="element-865" data-mp="3i8m168zfie4k">{children}</PageSourcesContext.Provider>;
}